import { Toaster as Sonner, toast } from "sonner";

/**
 * Global Sonner toaster for Zertivo.
 * Uses the Trustpilot-style light theme — white surface, subtle green accent,
 * readable dark text. Success / error / warning variants get a subtle tinted
 * border + icon color while keeping the body readable.
 */
const Toaster = ({ ...props }) => {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      position="top-right"
      toastOptions={{
        style: {
          background: '#FFFFFF',
          border: '1px solid #E4E4E7',
          color: '#09090B',
          boxShadow: '0 12px 30px -10px rgba(9, 9, 11, 0.12), 0 4px 10px -4px rgba(9, 9, 11, 0.06)',
          backdropFilter: 'blur(20px)',
          WebkitBackdropFilter: 'blur(20px)',
          fontFamily: "'Inter', system-ui, sans-serif",
          fontSize: '13px',
          padding: '14px 16px',
        },
        classNames: {
          toast: 'group !text-[#09090B]',
          title: '!text-[#09090B] !font-semibold',
          description: '!text-[#52525B]',
          success: '!border-[#00D387]/40 !text-[#09090B]',
          error:   '!border-[#EF4444]/40 !text-[#09090B]',
          warning: '!border-[#F59E0B]/50 !text-[#09090B]',
          info:    '!border-[#3B82F6]/40 !text-[#09090B]',
          actionButton: '!bg-[#0F8A5F] !text-white',
          cancelButton: '!bg-[#F9FAFB] !text-[#52525B]',
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
